import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Banner',
  props: {
    aspectRatio: null,
    backgroundImageLarge: null,
    backgroundImageSmall: null,
    logo: null,
    logoAltText: null,
    title: null
  },
  setup(__props: any) {

const props = __props as {
  aspectRatio?: number;
  backgroundImageLarge?: string;
  backgroundImageSmall?: string;
  logo?: string;
  logoAltText?: string;
  title?: string;
};



const bannerStyle = computed(() => {
  const style: Record<string, string> = {};

  if (props.aspectRatio) {
    style['--banner-aspect-ratio'] = `${props.aspectRatio}`;
  }

  if (props.backgroundImageLarge && props.backgroundImageSmall) {
    style['--banner-bg-image-lg-src'] = `url(${props.backgroundImageLarge})`;
    style['--banner-bg-image-src'] = `url(${props.backgroundImageSmall})`;
  } else {
    style['--banner-bg-image-src'] = `url(${
      props.backgroundImageLarge || props.backgroundImageSmall
    })`;
  }

  return style;
});

return { __sfc: true,props, bannerStyle }
}

})